import script from "./voting-slide.vue?vue&type=script&setup=true&lang=js"
export * from "./voting-slide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__